import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import authService from '../../services/authService';
import NotificationIcon from '../NotificationIcon';
import './Header.css';

function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  // Get user data from cookies
  const username = authService.getUser()?.username || 'support@btl86.com';

  const handleLogout = async () => {
    try {
      // Call logout API and clear cookies
      // await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
      // Clear cookies even if API call fails
      Cookies.remove('token', { path: '/' });
      Cookies.remove('user', { path: '/' });
    } finally {
      // Always navigate to login page
      navigate('/login');
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowUserMenu(false);
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          {/* Can add breadcrumbs or page title here */}
        </div>

        <div className="header-right">
          {/* User Menu */}
          <div className="header-item user-menu-container">
            <button
              className="user-menu-trigger"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">
                <i className="fas fa-user"></i>
              </div>
              <span className="user-email">{username}</span>
            </button>

            {showUserMenu && (
              <div className="user-menu-dropdown">
                {/* <div className="user-menu-item">
                  <i className="fas fa-user"></i>
                  <span>{t('header.profile')}</span>
                </div>
                <div className="user-menu-item">
                  <i className="fas fa-cog"></i>
                  <span>{t('header.settings')}</span>
                </div> */}
                <div className="user-menu-divider"></div>
                <div className="user-menu-section-title">
                  <i className="fas fa-language"></i>
                  <span>{t('language.switch')}</span>
                </div>
                <div
                  className={`user-menu-item language-item ${i18n.language === 'en' ? 'active' : ''}`}
                  onClick={() => changeLanguage('en')}
                >
                  <i className="fas fa-check"></i>
                  <span>{t('language.english')}</span>
                </div>
                <div
                  className={`user-menu-item language-item ${i18n.language === 'vi' ? 'active' : ''}`}
                  onClick={() => changeLanguage('vi')}
                >
                  <i className="fas fa-check"></i>
                  <span>{t('language.vietnamese')}</span>
                </div>
                <div className="user-menu-divider"></div>
                <div className="user-menu-item" onClick={handleLogout}>
                  <i className="fas fa-sign-out-alt"></i>
                  <span>{t('header.logout')}</span>
                </div>
              </div>
            )}
          </div>

          {/* Notifications */}
          <NotificationIcon />
        </div>
      </div>
    </header>
  );
}

export default Header;
